"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendSignedProposalRequestSchema = void 0;
const zod_1 = require("zod");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const userWithUserId_schema_1 = require("../../../common/schemas/userWithUserId.schema");
const contact_schema_1 = require("../../../common/schemas/contact.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const Purpose_1 = require("../../types/Purpose");
exports.sendSignedProposalRequestSchema = zod_1.z
    .object({
    remarks: longField_schema_1.longFieldSchema.optional(),
    from: userWithUserId_schema_1.userWithUserIdSchema,
    to: contact_schema_1.contactSchema.array().nonempty(),
    cc: contact_schema_1.contactSchema.array().optional(),
    version: zod_1.z.string(),
    attachments: zod_1.z
        .object({
        uploadIds: zod_1.z.string().array().nonempty().optional(),
        mostRecentWorkflowActionFileIds: zod_1.z.string().array().nonempty().optional(),
    })
        .strict()
        .superRefine((data, context) => {
        var _a, _b;
        if (!((_a = data.uploadIds) === null || _a === void 0 ? void 0 : _a.length) && !((_b = data.mostRecentWorkflowActionFileIds) === null || _b === void 0 ? void 0 : _b.length)) {
            context.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "At least one of uploadIds or mostRecentWorkflowActionFileIds must be provided",
            });
        }
    }),
    purpose: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForReview,
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForUpdatedQuote,
        Purpose_1.Purpose.NewQuote,
    ]),
})
    .strict();
//# sourceMappingURL=sendSignedProposalRequest.schema.js.map